import { relevancySortingQueryParams } from '../../../shared/domains/sorting/specifications/sorting';

export const getDefaultSortParams = () => relevancySortingQueryParams;
